import { useCallback, useEffect, useState } from 'react';
import { networkChaos } from 'modules/overlay-v2/domain/utils/network-chaos';

interface NetworkChaosState {
  isPoorNetwork: boolean;
  isFlapping: boolean;
  isOffline: boolean;
  togglePoorNetwork: () => void;
  toggleFlapping: () => void;
}

/** Отладочное управление эмуляцией плохого интернета (IMGM-1435). */
export function useNetworkChaos(): NetworkChaosState {
  const [, forceUpdate] = useState(0);

  useEffect(() => networkChaos.subscribe(() => forceUpdate((value) => value + 1)), []);

  useEffect(() => () => networkChaos.stopAll(), []);

  const togglePoorNetwork = useCallback(() => {
    if (networkChaos.isPoorNetwork) networkChaos.disablePoorNetwork();
    else networkChaos.enablePoorNetwork();
  }, []);

  const toggleFlapping = useCallback(() => {
    if (networkChaos.isFlapping) networkChaos.stopFlapping();
    else networkChaos.startFlapping();
  }, []);

  return {
    isPoorNetwork: networkChaos.isPoorNetwork,
    isFlapping: networkChaos.isFlapping,
    isOffline: networkChaos.isOffline,
    togglePoorNetwork,
    toggleFlapping,
  };
}

export default useNetworkChaos;
